import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { TabPosition } from '@progress/kendo-angular-layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TabContentRemoteDto } from '../../../../../../generated/swagger';
import { PresentationType } from '../../../../../samwebDescription/samweb/settings/presentationType';
import { TabBrickSettingsState } from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/tab-brick-settings/tab-brick-settings.state';

@Component({
   selector: 'samweb-tab-brick-title',
   templateUrl: './tab-brick-title.component.html',
   styleUrls: ['./tab-brick-title.component.scss'],
})
export class TabBrickTitleComponent implements OnInit {
   constructor(private store: Store) {}

   @Input()
   public tabHostBrickInstanceId: string;

   @Input()
   public tab: TabContentRemoteDto;

   @Input()
   public tabPosition: TabPosition;

   public tabPresentationType$: Observable<PresentationType>;

   ngOnInit() {
      this.tabPresentationType$ = this.store.select(TabBrickSettingsState.getPresentationType).pipe(map((fn) => fn(this.tabHostBrickInstanceId)));
   }
}
